import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const Search: React.FC<IIconProps> = ({
  size = IconSizes.md,
  color = 'black',
  UNSAFE_className = '',
  ...props
}) => (
  <svg
    width={IconWidth[size]}
    height={IconHeight[size]}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={UNSAFE_className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.272 4.25581C7.39706 4.25581 4.25581 7.39706 4.25581 11.272C4.25581 15.1469 7.39706 18.2882 11.272 18.2882C15.1469 18.2882 18.2882 15.1469 18.2882 11.272C18.2882 7.39706 15.1469 4.25581 11.272 4.25581ZM3 11.272C3 6.7035 6.7035 3 11.272 3C15.8405 3 19.544 6.7035 19.544 11.272C19.544 13.3302 18.7923 15.2129 17.5484 16.6604L20.8161 19.9281C21.0613 20.1733 21.0613 20.5709 20.8161 20.8161C20.5709 21.0613 20.1733 21.0613 19.9281 20.8161L16.6604 17.5484C15.2129 18.7923 13.3302 19.544 11.272 19.544C6.7035 19.544 3 15.8405 3 11.272Z"
      fill={color}
    />
  </svg>
);

export default Search;
